import React, { useMemo } from 'react'

import { Notification } from '@mindfulchefuk/design-system'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import plural from '@mindfulchefuk/utils/plural'

export const OnboardingCartDrawerCallout = () => {
  const {
    minimumRecipesForPortion,
    maximumRecipesForPortion,
    totalNumberOfRecipes,
  } = useChooseRecipesContext()

  const minimumNotReached = totalNumberOfRecipes < minimumRecipesForPortion

  const title = useMemo(
    () =>
      totalNumberOfRecipes < maximumRecipesForPortion
        ? `${totalNumberOfRecipes} ${plural('recipe')(
            totalNumberOfRecipes
          )} selected`
        : 'Recipe box full',
    [maximumRecipesForPortion, totalNumberOfRecipes]
  )

  const copy = useMemo(() => {
    if (minimumNotReached) {
      const minAdditional = minimumRecipesForPortion - totalNumberOfRecipes
      const maxAdditional = maximumRecipesForPortion - totalNumberOfRecipes

      return `Add ${minAdditional} to ${maxAdditional} to continue`
    } else if (totalNumberOfRecipes < maximumRecipesForPortion) {
      return `You can add up to ${maximumRecipesForPortion}`
    } else {
      return 'Congrats on being so planet-friendly!'
    }
  }, [
    minimumNotReached,
    minimumRecipesForPortion,
    maximumRecipesForPortion,
    totalNumberOfRecipes,
  ])

  return (
    <Notification
      id="recipes-section-info-text"
      my={14}
      type="inline"
      variant={minimumNotReached ? 'warning' : 'success'}
      icon="recipes"
      iconColor="aubergine"
      color="aubergine"
      title={title}
    >
      {copy}
    </Notification>
  )
}
